// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".chatIcon__chatIcon___ZKcMK{width:100%;height:100%;background-repeat:no-repeat;background-position:center center}.chatIcon__chatIcon___ZKcMK.chatIcon__pointer___2Ud3k{cursor:pointer}", ""]);
// Exports
exports.locals = {
	"white": "#fff",
	"primary": "#222",
	"secondary": "#717070",
	"primaryBlue": "#336dec",
	"primaryDarkerBlue": "#005bcc",
	"chatIconFrameWidth": "70px",
	"chatIconFrameHeight": "70px",
	"widgetFrameWidth": "400px",
	"widgetFrameHeight": "650px",
	"mobileScreenWidth": "550px",
	"mobileScreenHeight": "550px",
	"chatIcon": "chatIcon__chatIcon___ZKcMK",
	"pointer": "chatIcon__pointer___2Ud3k"
};
module.exports = exports;
